import {Record, List} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';
import type * as Model from './model';

export class BillingOverviewState extends Record<{
    readonly loading: boolean;
    readonly famlyBillPayersInfo: List<Model.FamlyBillPayerInfo>;
    readonly showNotification: boolean;
    readonly balance: string;
    readonly billingActivityItems: List<Model.BillingActivityItem>;
    readonly fetchingBalance: boolean;
}>({
    loading: false,
    famlyBillPayersInfo: List(),
    showNotification: false,
    balance: '',
    billingActivityItems: List(),
    fetchingBalance: false,
}) {}

export default makeReducer<BillingOverviewState>(
    [
        match(
            Actions.fetchFamlyBillPayersInfo,
            () =>
                new BillingOverviewState({
                    loading: true,
                }),
        ),
        match(Actions.fetchFamlyBillPayersInfoSuccess, (state, {payload}) =>
            state.merge({
                loading: false,
                famlyBillPayersInfo: payload.famlyBillPayersInfo.sort((a, b) => (a.overdue >= b.overdue ? -1 : 1)),
                showNotification: payload.showNotification,
            }),
        ),
        match(Actions.fetchFamlyBillPayersInfoFailed, state =>
            state.merge({
                loading: false,
            }),
        ),
        match(Actions.updateFamlyBillPayer, (state, {payload}) => {
            const newFamlyBillPayersInfo = state.famlyBillPayersInfo.map(famlyBillPayerInfo =>
                famlyBillPayerInfo.billPayer.billPayerId === payload.billPayer.billPayerId
                    ? {...famlyBillPayerInfo, billPayer: payload.billPayer}
                    : famlyBillPayerInfo,
            );
            return state.merge({
                famlyBillPayersInfo: newFamlyBillPayersInfo,
            });
        }),
        match(Actions.fetchBalance, state => state.merge({fetchingBalance: true})),
        match(Actions.fetchBalanceFailed, state => state.merge({fetchingBalance: false})),
        match(Actions.fetchBalanceSuccess, (state, {payload}) =>
            state.merge({
                fetchingBalance: false,
                balance: payload.balance,
                billingActivityItems: payload.billingActivityItems,
            }),
        ),
    ],
    new BillingOverviewState(),
);
